import { render } from "./Footer.vue?vue&type=template&id=c113d0de"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=c113d0de&lang=css"
script.render = render

export default script